var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5549 2.29976L13.1387 5.49359C13.3547 5.93818 13.9306 6.36463 14.4166 6.44629L17.2872 6.92718C19.123 7.23567 19.555 8.57853 18.2321 9.90325L16.0004 12.1534C15.6224 12.5345 15.4154 13.2695 15.5324 13.7957L16.1714 16.5812C16.6753 18.7861 15.5144 19.639 13.5796 18.4867L10.8889 16.8807C10.403 16.5903 9.60209 16.5903 9.10714 16.8807L6.41644 18.4867C4.49065 19.639 3.32078 18.777 3.82473 16.5812L4.46366 13.7957C4.58064 13.2695 4.37367 12.5345 3.99571 12.1534L1.76395 9.90325C0.4501 8.57853 0.873053 7.23567 2.70885 6.92718L5.57953 6.44629C6.05648 6.36463 6.63242 5.93818 6.84839 5.49359L8.43222 2.29976C9.29612 0.566747 10.7 0.566747 11.5549 2.29976Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.d476bdef1f35de046641939d9223f42c.svg";
export { ForwardRef as ReactComponent };